import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { format } from 'app/shared/utils/string.util';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';

const cognitiveServiceKeySelect: ControlMetadata = {
    type: 'azure-key-vault',
    bind: 'csKey',
    isLabelVertical: true,
    enableAKVParameterization: true,
    description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
        stringResources.CognitiveService_DisplayText,
        stringResources.ModelName_CognitiveServiceKey)
};

export const cognitiveServiceMetaData: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.cognitiveService.linkedServiceType,
    displayName: stringResources.CognitiveService_DisplayText,
    icon: {
        className: 'svg-i-100x100-CognitiveService'
    },
    category: ['Azure'],
    isFirstClass: true,
    supportPE: true,
    peGroupIDs: ['account'],
    disableQueryAPI: true,
    notSupportCopySource: true,
    notSupportCopySink: true,
    copySinkTypes: [],
    copySourceTypes: [],
    controls: [
        {
            type: 'radio-switch',
            nested: 1,
            label: stringResources.CognitiveService_SelectionMethod,
            description: stringResources.CognitiveService_SelectMethodDescription,
            options: azureResourceSelectMethodOptions,
            defaultValue: '{csName != null ? "manual" : "azure"}',
            isLabelVertical: true,
            cases: [
                {
                    caseValue: 'azure',
                    children: [
                        {
                            type: 'cognitive-service-select',
                            bind: {
                                subscriptionId: 'subscriptionId',
                                resourceGroup: 'resourceGroup',
                                csName: 'csName',
                                csKind: 'csKind',
                                csLocation: 'csLocation',
                                endPoint: 'endPoint',
                                resourceID: '_accountResourceID'
                            },
                            showPEStatus: true,
                            validators: {
                                endPoint: [
                                    { type: 'required', errorMessage: '' }
                                ]
                            }
                        },
                        cognitiveServiceKeySelect
                    ]
                },
                {
                    caseValue: 'manual',
                    children: [
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'subscriptionId',
                                label: stringResources.SubscriptionId,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'resourceGroup',
                                label: stringResources.ResourceGroup,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'csName',
                                label: stringResources.Name,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'csKind',
                                label: stringResources.ModelName_CognitiveServiceKind,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'csLocation',
                                label: stringResources.ModelName_CognitiveServiceLocation,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'endPoint',
                                label: stringResources.ModelName_CognitiveServiceEndPoint,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        },
                        {
                            type: 'private-endpoint-status'
                        },
                        cognitiveServiceKeySelect
                    ]
                }
            ]
        }
    ]
};
